import { createFileRoute } from "@tanstack/react-router";

import { createHead } from "@/components/createHead";
import MarketingFooter from "@/components/MarketingFooter";
import { MarketingNavBar } from "@/components/MarketingNavBar";
import { Picture } from "@/components/Picture";
import { StickyNav } from "@/components/StickyNav";
import { ButtonLink } from "@/components/ui/button";
/* eslint-disable import-x/no-duplicates */
// @ts-expect-error TODO: fix this
import card4 from "@/images/illustration.png?slice=1&height=221&width=306&x=1052&y=963";
// @ts-expect-error TODO: fix this
import card3 from "@/images/illustration.png?slice=1&height=221&width=306&x=1382&y=1740";
// @ts-expect-error TODO: fix this
import card2 from "@/images/illustration.png?slice=1&height=221&width=396&x=105&y=434";
// @ts-expect-error TODO: fix this
import card1 from "@/images/illustration.png?slice=1&height=321&width=306&x=1600&y=917";
// @ts-expect-error TODO: fix this
import heroIllustration from "@/images/illustration.png?slice=1&height=400&width=400&x=1552&y=1400";
/* eslint-enable import-x/no-duplicates */
import sparkImg from "@/images/spark.webp?w=500;900;1200&format=avif;webp;jpg&as=picture";

export const Route = createFileRoute("/feed-curators")(
  {
    component: RouteComponent,
    head: ({ match: { pathname } }) =>
      createHead({
        title: "Feed Curators | Graze",
        ogTitle: "Feed Curators",
        description: "Feed Curators for Graze.social",
        pathname,
        ogImage: "/feed-curators.png",
      }),
  },
);

function RouteComponent() {
  return (
    <>
      <div className="min-h-screen bg-slate-app instrument-sans text-slate-normal">
        <header className="bg-slate-10 dark:bg-slatedark-10 text-slate-contrast dark:text-slatedark-contrast">
          <div className="flex items-center gap-12 mx-auto container px-4">
            <div className="h-full items-center justify-center hidden md:flex flex-1 @container">
              <div className="relative flex items-center justify-center">
                <div
                  className="sharp-grotesk text-[100cqw] leading-[0.9] big-g-scroll"
                  style={{
                    backgroundImage: `url('${heroIllustration}')`,
                    backgroundSize: "100cqw",
                    backgroundClip: "text",
                    color: "transparent",
                    textShadow: "none",
                  }}
                >
                  G
                </div>
                <div className="absolute right-[4.5cqw] bottom-[5cqw] text-slate-12 instrument-serif text-[15cqw] italic">
                  Graze
                </div>
              </div>
            </div>
            <div className="flex-1 py-6 md:py-10 flex flex-col @container">
              <div className="flex mb-2 md:mb-16 md:justify-end sticky top-[-100%]">
                <MarketingNavBar onlyNav variant="light" />
              </div>
              <h1 className="text-[14cqw] instrument-serif bold mb-8 leading-none">
                Community builders deserve better
              </h1>
              <div className="mb-6 md:mb-8 flex flex-col gap-4 max-w-[68ch] border-2 border-slate-11 dark:border-slatedark-11 rounded-xl p-4 bg-white/30 dark:bg-black/30">
                <p className="text-xl md:text-2xl font-medium leading-relaxed">
                  Building communities is a lot of work. On traditional
                  platforms, your reward? Maybe a "thanks". With Graze, you
                  finally get the tools and infrastructure to turn that
                  expertise into something more.
                </p>
              </div>
            </div>
          </div>
        </header>

        <StickyNav variant="slate" />

        <section className="py-6 md:py-16">
          <div className="container mx-auto p-4 md:px-12 flex flex-col gap-8 md:gap-16">
            <h2 className="text-4xl md:text-6xl font-bold instrument-serif">
              How Graze Changes Everything
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <div className="flex flex-col border-slate-7 dark:border-slatedark-7 hover:border-slate-9 hover:dark:border-slatedark-9 eoverflow-hidden border-2 rounded-lg">
                <div
                  className="h-[150px] md:h-[200px] bg-cover bg-center bg-no-repeat"
                  style={{
                    backgroundImage: `url('${card1}')`,
                  }}
                ></div>
                <div className="p-4 md:p-8 flex flex-col gap-2 border-t border-slate-7 dark:border-slatedark-7">
                  <div className="text-3xl md:text-4xl font-bold instrument-serif">
                    Direct Monetization
                  </div>
                  <div className="text-lg">
                    Stop working for free and get compensated for the value you
                    create.
                  </div>
                </div>
              </div>
              <div className="flex flex-col border-slate-7 dark:border-slatedark-7 hover:border-slate-9 hover:dark:border-slatedark-9 eoverflow-hidden border-2 rounded-lg">
                <div
                  className="h-[150px] md:h-[200px] bg-cover bg-center bg-no-repeat"
                  style={{
                    backgroundImage: `url('${card2}')`,
                  }}
                ></div>
                <div className="p-4 md:p-8 flex flex-col gap-2 border-t border-slate-7 dark:border-slatedark-7">
                  <div className="text-3xl md:text-4xl font-bold instrument-serif">
                    Your Audience, Your Rules
                  </div>
                  <div className="text-lg">
                    Build direct relationships with advertisers. Approve or deny
                    every ad. No black box algorithms decide what your followers
                    see.
                  </div>
                </div>
              </div>
              <div className="flex flex-col border-slate-7 dark:border-slatedark-7 hover:border-slate-9 hover:dark:border-slatedark-9 eoverflow-hidden border-2 rounded-lg">
                <div
                  className="h-[150px] md:h-[200px] bg-cover bg-center bg-no-repeat"
                  style={{
                    backgroundImage: `url('${card3}')`,
                  }}
                ></div>
                <div className="p-4 md:p-8 flex flex-col gap-2 border-t border-slate-7 dark:border-slatedark-7">
                  <div className="text-3xl md:text-4xl font-bold instrument-serif">
                    Portable & Future-Proof
                  </div>
                  <div className="text-lg">
                    Your audience stays with you thanks to ATProto. No platform
                    lock-in, no starting over from zero.
                  </div>
                </div>
              </div>
              <div className="flex flex-col border-slate-7 dark:border-slatedark-7 hover:border-slate-9 hover:dark:border-slatedark-9 eoverflow-hidden border-2 rounded-lg">
                <div
                  className="h-[150px] md:h-[200px] bg-cover bg-center bg-no-repeat"
                  style={{
                    backgroundImage: `url('${card4}')`,
                  }}
                ></div>
                <div className="p-4 md:p-8 flex flex-col gap-2 border-t border-slate-7 dark:border-slatedark-7">
                  <div className="text-3xl md:text-4xl font-bold instrument-serif">
                    Real Insights
                  </div>
                  <div className="text-lg">
                    See exactly who's reading, what's working, and how to grow
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-16 bg-teal-4 dark:bg-tealdark-4">
          <div className="container @container mx-auto grid relative z-0 px-4">
            <div
              className="flex flex-col justify-center items-center lg:container mx-auto gap-4 bg-position-[-11cqw_-314cqw]"
              style={{
                textShadow: "0 0 0 rgba(255, 255, 255, 0.1)",
              }}
            >
              <div className="leading-relaxed instrument-serif w-full text-[4cqw] md:text-[3.2cqw] text-center">
                With custom feeds powering communities like BookSky, Game Dev,
                Medsky and more,
                <br />
                Graze helps builders grow and foster their communities.
              </div>
            </div>
          </div>
        </section>

        <section className="py-6 md:py-16 bg-slate-3 dark:bg-slatedark-3">
          <div className="container mx-auto p-4 md:px-12 flex flex-col gap-8 md:gap-16">
            <h2 className="text-4xl md:text-6xl font-bold instrument-serif">
              Real Curator Success
            </h2>
            <div className="flex flex-col lg:flex-row gap-10 md:gap-16">
              <div className="flex-1 flex flex-col gap-10">
                <p className="text-xl md:text-3xl max-w-[68ch] leading-relaxed">
                  Feeds have the power to take control of your content and your
                  audience like never before. They flip the script on the big
                  tech platforms and give you the tools to build the future of
                  social, and pay you for your work.
                </p>
              </div>
              <div className="flex flex-col lg:flex-row gap-4 shrink-0 flex-1">
                <div className="max-w-[800px] shrink-0 md:flex-1 flex items-center bg-teal-10 dark:bg-tealdark-10 text-teal-contrast dark:text-tealdark-contrast @ border-2 border-teal-11 dark:border-tealdark-11 rounded-lg @container">
                  <div className="p-8 flex flex-col items-end gap-8">
                    <div className="flex items-center md:items-start gap-8">
                      <div className="shrink-0 h-[100px] w-[100px]">
                        <img
                          src="https://cdn.bsky.app/img/avatar_thumbnail/plain/did:plc:kkf4naxqmweop7dv4l2iqqf5/bafkreicxyrwjzitextucvgfx3mkw4ekpjoctg6mei2btqtwoq7m4l473oi@jpeg"
                          alt=""
                          className="h-full w-full rounded-full border-2"
                        />
                      </div>
                      <div className="text-lg md:text-xl leading-relaxed">
                        Graze totally changed how I run my feeds. Before Graze,
                        I had no stats and my feeds seldom received updates.
                        Graze has dramatically improved the quality of my feeds
                        and I finally have insights into how many people are
                        using them, plus feed monetisation has meant I've been
                        able to donate over half a grand to developers building
                        cool things on Bluesky. Graze is truly Bluesky/ATProto's
                        first killer app.
                      </div>
                    </div>
                    <div className="text-lg md:text-xl instrument-serif">
                      ~ Ændra,{" "}
                      <a
                        href="https://bsky.app/profile/did:plc:kkf4naxqmweop7dv4l2iqqf5/feed/verified-news"
                        className="underline decoration-wavy underline-offset-8 hover:decoration-solid"
                      >
                        Verified News Feed Operator
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <section className="py-6 md:py-16 bg-slate-9 dark:bg-slatedark-9 text-slate-contrast dark:text-slatedark-contrast relative">
        <div className="absolute top-2 md:top-6 xl:top-12 left-6 flex items-center justify-center w-[80px] md:w-[10%] z-0">
          <Picture src={sparkImg} alt="" className="h-full w-full" />
        </div>
        <div className="container mx-auto p-4 md:px-12 flex flex-col gap-8 md:gap-12 relative z-1">
          <h2 className="text-4xl md:text-6xl font-bold instrument-serif text-center text-shadow-lg md: max-w-[60vw] mx-auto leading-tight">
            Join the Movement
          </h2>
          <p className="text-lg md:text-xl max-w-[80ch] leading-relaxed mx-auto">
            Stop subsidizing big tech. Start building the distributed web where
            community builders are valued, respected, and rewarded.
          </p>
          <div className="flex gap-4 justify-center">
            <ButtonLink to="/login">Get Started with Graze</ButtonLink>
          </div>
        </div>
      </section>

      <MarketingFooter showStartSection={false} />
    </>
  );
}
